var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.fullscreen')
    }
  }, [_c('el-switch', {
    model: {
      value: (_vm.optionModel.fullscreen),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "fullscreen", $$v)
      },
      expression: "optionModel.fullscreen"
    }
  })], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3b23113f","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/container-vf-dialog/fullscreen-editor.vue
// module id = null
// module chunks = 